<template>
  <div class="relative">
    <button
      @click="dropdownOpen = !dropdownOpen"
      class="flex mx-4 focus:outline-none text-white border border-gray-50 p-2 rounded-lg"
    >
      <span class="mr-2">{{ `${activeLocate.name}` }}</span>
      <svg
        v-if="dropdownOpen"
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
          clip-rule="evenodd"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <div
      v-show="dropdownOpen"
      @click="dropdownOpen = false"
      class="fixed inset-0 h-32 w-full z-10"
    ></div>
    <div
      v-show="dropdownOpen"
      class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-xl z-20"
    >
      <template v-for="locate in locales" :key="locate.code">
        <a
          href="#"
          class="
            block
            px-4
            py-2
            text-sm
            font-light
            tracking-wide
            text-black
            uppercase
            hover:bg-indigo-900
            hover:text-white
          "
          @click="changeLanguage(locate)"
        >
          {{ locate.name }}
        </a>
      </template>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import userApis from "../../api/user";
import { useStore } from "vuex";
import { computed, ref, watch } from "vue";

export default {
  setup() {
    const { t, locale } = useI18n({ useScope: "global" });
    const store = useStore();
    const dropdownOpen = ref(false);
    watch(dropdownOpen, (value) => {
      console.log('dropdownOpen', value);
    })
    const locales = ref([
      {
        code: "en",
        name: "English",
      },
      {
        code: "vi",
        name: "Tiếng Việt",
      },
    ]);
    const userId = computed(() => store.state.userId);
    const defaultLocaleCode = computed(() => store.state.locale);

    locale.value = localStorage.getItem('language');
    const index = locale.value === "en" ? 0 : 1;
    const activeLocate = ref(locales.value[index]);

    watch(defaultLocaleCode, (newLocale) => {
      locale.value = newLocale;
      activeLocate.value = locales.value.find(
          (item) => item.code === newLocale
      );
    });

    const changeLanguage = async function (lo) {
      activeLocate.value = lo;
      locale.value = lo.code;
      localStorage.setItem('language', lo.code);
      dropdownOpen.value = false;
      try {
        const { data } = await userApis.updateUser(userId.value, {
          locale: lo.code,
        });
      } catch {
        console.log("Can not set locale");
      }
    };

    return {
      dropdownOpen,
      changeLanguage,
      activeLocate,
      locales,
    };
  },
};
</script>